import { immer } from "zustand/middleware/immer";
import { createWithEqualityFn } from "zustand/traditional";

export interface BookingState {
  pair_index: number;
  symbol: string;
  open_interest_long: string; // thường là BigNumber hoặc string do giá trị lớn
  open_interest_short: string;
  max_open_interest: string;
  funding_rate_long: string; // tỷ lệ thường để string hoặc number nếu đã convert
  funding_rate_short: string;
  rollover_rate: string;
  max_leverage: number;
  spread: string;
  one_percent_depth_above: string;
  one_percent_depth_below: string;
  open_fee: string;
  nft_limit_order_fee: string;
}

export interface RawPairInfo {
  pairIndex: string;
  symbol: string;
  openInterestLong: string;
  openInterestShort: string;
  maxOpenInterest: string;
  fundingRateLong: string;
  fundingRateShort: string;
  rolloverRate: string;
  marketCap: string | null;
  fdv: string | null;
  maxSupply: string | null;
  maxLeverage: string;
  spread: string;
  onePercentDepthAbove: string;
  onePercentDepthBelow: string;
}

interface AppState {
  booking: BookingState[];

  setBookingData: (dataSocket: BookingState[]) => void;

  resetOrderTradeData: () => void;
}

export const useTradeStore = createWithEqualityFn<AppState, [["zustand/immer", never]]>(
  immer((set) => ({
    booking: [],
    resetOrderTradeData: () => {
      set((state) => {
        state.booking = [];
      });
    },
    setBookingData: (dataSocket: BookingState[]) => {
      set((state) => {
        state.booking = dataSocket;
      });
    },
  }))
);
